import { z } from 'zod';

export const GoogleUserSchema = z.object({
  provider: z.string(),
  sub: z.string(),
  email: z.string(),
  name: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  nickName: z.string(),
  description: z.string(),
  avatarUrl: z.string(),
  location: z.string(),
  expiresAt: z.string(),
  userId: z.string(),
});
